var _style, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#9B9591;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,30C6.7,30,0,23.3,0,15S6.7,0,15,0s15,6.7,15,15S23.3,30,15,30z M15,2C7.8,2,2,7.8,2,15s5.8,13,13,13 s13-5.8,13-13S22.2,2,15,2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,20c-1.6,0-3.1-0.8-4.2-2.3C9.7,16.4,9,14.6,9,13c0-1.8,0.4-3.2,1.3-4.2C11.3,7.6,12.9,7,15,7 s3.7,0.6,4.7,1.8c0.9,1,1.3,2.4,1.3,4.2c0,1.6-0.7,3.4-1.8,4.7C18.1,19.2,16.6,20,15,20z M15,9c-1.5,0-2.6,0.4-3.2,1.1 C11.3,10.7,11,11.7,11,13c0,1.2,0.5,2.5,1.3,3.5S14.1,18,15,18s1.9-0.6,2.7-1.5c0.8-1,1.3-2.3,1.3-3.5c0-1.3-0.3-2.3-0.8-2.9 C17.6,9.4,16.5,9,15,9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.9,26.4l-1.8-0.8C6.2,25.4,8.7,20,15,20s8.8,5.4,8.9,5.6l-1.8,0.8C22,26.2,20,22,15,22S8,26.2,7.9,26.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.4135fa06ca78ba894bc348b7d28003ad.svg";
export { ForwardRef as ReactComponent };